const Statistics = () => import('@/views/main/material/statistics/Statistics.vue')
export default {
  path: '/main/material/statistics',
  name: 'Statistics',
  component: Statistics,
  children: []
}
